import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import FontField from '../../../../../form-fields/super-cut/font'

const Font = styled(FontField)`
    grid-column: span 1;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoFontField = ({ field }: Props) => {
    return (
        <Font
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoFontField
